"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExpressionVariables = void 0;
const rdf_terms_1 = require("rdf-terms");
const sparqlalgebrajs_1 = require("sparqlalgebrajs");
/**
 * Get all variables inside the given expression.
 * @param expression An expression.
 * @return An array of variables, which can be empty.
 */
function getExpressionVariables(expression) {
    switch (expression.expressionType) {
        case sparqlalgebrajs_1.Algebra.expressionTypes.AGGREGATE:
        case sparqlalgebrajs_1.Algebra.expressionTypes.WILDCARD:
            throw new Error(`Getting expression variables is not supported for ${expression.expressionType}`);
        case sparqlalgebrajs_1.Algebra.expressionTypes.EXISTENCE:
            return sparqlalgebrajs_1.Util.inScopeVariables(expression.input);
        case sparqlalgebrajs_1.Algebra.expressionTypes.NAMED:
            return [];
        case sparqlalgebrajs_1.Algebra.expressionTypes.OPERATOR:
            return (0, rdf_terms_1.uniqTerms)(expression.args.flatMap(arg => getExpressionVariables(arg)));
        case sparqlalgebrajs_1.Algebra.expressionTypes.TERM:
            if (expression.term.termType === 'Variable') {
                return [expression.term];
            }
            return [];
    }
}
exports.getExpressionVariables = getExpressionVariables;
//# sourceMappingURL=Expressions.js.map